import { message, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";
import restful from "../../restful";
import { CompareFn, SortOrder } from "antd/lib/table/interface";

interface DataType {
    service: string;
    name: string;
    category: string;
    rate: number;
    min: string;
    max: string;
    type: string;
    desc: string;
    dripfeed: string;
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const FollowermaServicesTable: FC = () => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);


    const columns: ColumnsType<DataType> = [
        { sorter: (a, b) => a.service.localeCompare(b.service), title: 'service', dataIndex: 'service', key: 'service' },
        { sorter: (a, b) => a.name.localeCompare(b.name), ellipsis: true,title: 'name', dataIndex: 'name', key: 'name' },
        { sorter: (a, b) => a.category.localeCompare(b.category),ellipsis: true, title: 'category', dataIndex: 'category', key: 'category' },
        { sorter: (a, b) => a.rate > b.rate ? 1 : -1, title: 'rate', dataIndex: 'rate', key: 'rate' },
        { sorter: (a, b) => a.min.localeCompare(b.min), title: 'min', dataIndex: 'min', key: 'min' },
        { sorter: (a, b) => a.max.localeCompare(b.max), title: 'max', dataIndex: 'max', key: 'max' },
        { sorter: (a, b) => a.type.localeCompare(b.type), title: 'type', dataIndex: 'type', key: 'type' },
        { sorter: (a, b) => a.desc.localeCompare(b.desc), ellipsis: true, title: 'desc', dataIndex: 'desc', key: 'desc' },
        { sorter: (a, b) => a.dripfeed.localeCompare(b.dripfeed), title: 'dripfeed', dataIndex: 'dripfeed', key: 'dripfeed' },
    ];

    const fetchData = () => {
        setIsLoaded(true);
        restful.get(`/followerma/services`,)
            .then((res) => {
                const result = res.data.result
                setItems(result.services);
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData();
    }, [])

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="service"
    />
}

export default FollowermaServicesTable


